import { useAppSelector } from '../../../Hooks/useAppSelector'
import { ShipmentItemsSelectors } from '../StoreAdapter'

export const useShipmentItemsSelector = () => {
  return useAppSelector(ShipmentItemsSelectors.selectEntities)
}
